export default __webpack_public_path__ + "static/media/locationWhite.267a03ba.svg";